<template>
    <div>
        <news-base-header-sec></news-base-header-sec>

        <div class="container-fluid base-container">
            <div class="base-box base-box__table-sec">
                <div class="card-body ac_card-body">

                    <ul class="ac_collapse__item-list">
                        <template v-for="news in newsList">

                            <news-list-element-component :news="news" v-bind:key="news.id"></news-list-element-component>
                        </template>
                    </ul>

                </div>
                <div class="card-footer border-bottom">

                    <nav>
                        <ul class="pagination">
                            <li class="page-item ">
                                <button class="page-link" @click.prevent='handleNewsPageDown' href="#"
                                    :disabled="routePage == 0">
                                    <span class="icon-chevrons-left mr-2"></span>
                                    Претходне вести
                                </button>

                            </li>
                            <li class="page-item">
                                <button class="page-link" @click.prevent='handleNewsPageUp' href="#">Још вести <span
                                        class="icon-chevrons-right ml-2"></span></button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import NewsBaseHeaderSec from '@/components/NewsBaseHeaderSec.vue';
import NewsListElementComponent from '@/components/NewsListElementComponent.vue';



export default {
    name: "NewsCategoryPage",
    data() {
        return {
            pageCounter: 0,
            newsList: null,
            baseApiUrl: window.env.VUE_APP_API_DI_DEV,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        NewsListElementComponent,
        NewsBaseHeaderSec
    },

    watch: {
        $route() {
            // console.log(to);
            // console.log(from);
            this.fetchNewsData();
        }
    },

    methods: {
        handleNewsPageDown() {
            // this.router.push({ name: 'NewsCategoryPage', params: { userId: '123' } });
            let newPageNum;
            let category = this.$route.params.id;

            if (this.$route.params.page > 0) {
                newPageNum = Number(this.$route.params.page) - 1;
            } else {
                newPageNum = 0
            }

            this.$router.push({ name: 'NewsCategoryPage', params: { id: category, page: newPageNum } });
            this.pageCounter++;
        }, handleNewsPageUp() {
            // this.router.push({ name: 'NewsCategoryPage', params: { userId: '123' } });
            let newPageNum = Number(this.$route.params.page) + 1;
            let category = this.$route.params.id;

            this.$router.push({ name: 'NewsCategoryPage', params: { id: category, page: newPageNum } });
            this.pageCounter++;
        },
        fetchNewsData() {
            axios
                .get(this.baseApiUrl + 'FP/SearchByCategory?category=' + this.$route.params.id + '&page=' + this.$route.params.page + '&take=10')
                .then(response => {

                    this.newsList = response.data;
                }).catch(function (error) {
                    console.log(error);
                });
        }
    },
    computed: {
        routePage: function () {
            return Number(this.$route.params.page)
        }
    },
    mounted() {
        this.fetchNewsData();
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}
</script>


<style>
.main {
    background-color: #ddd !important;
    padding-bottom: 360px !important;
}
</style>
